import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { Entity } from "../../../../../../types/types/entity.types";

import InfoCards from "./InfoCards";
import EntityAbout from "./EntityAbout";

interface GeneralInfoProps {
  entity?: Entity;
  isLoading: boolean;
}

const GeneralInfo = ({ entity, isLoading }: GeneralInfoProps) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "generalInfo",
  });
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("generalInfo")}</Typography>
      <InfoCards entity={entity} isLoading={isLoading} />
      <EntityAbout bio={entity?.about} isLoading={isLoading} />
    </Box>
  );
};

export default GeneralInfo;

const styles = {
  container: {
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
};
